
import { compose } from 'recompose';
import ArchivedEmailDetails from './Details';
import apiInterceptor from '../../../api/interceptor';
import { archivedEmailApi } from '../../common/base.api';

const composedArchivedEmailDetails = compose(apiInterceptor({ ...archivedEmailApi }))(ArchivedEmailDetails);

export default composedArchivedEmailDetails;
